import * as faceapi from "face-api.js";
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { post } from "../../util/request";
import { useNavigate } from "react-router-dom";
import Kodir from "./kodir1.jpg";
import { decode } from "base-64";

export default function Absen() {
  const navigate = useNavigate();

  const [myFace, setMyFace] = React.useState("");
  const [modelsLoaded, setModelsLoaded] = React.useState(false);
  const [captureVideo, setCaptureVideo] = React.useState(true);
  const [toggleButton, setToggleButton] = React.useState(false);
  const videoRef = React.useRef();
  // const videoHeight = 480;
  // const videoWidth = 640;
  const videoWidth = 425; // Updated maximum width
  const videoHeight = 425; // Adjusted height to maintain aspect ratio
  const canvasRef = React.useRef();
  const [capturedPhoto, setCapturedPhoto] = React.useState(null);
  const user = useSelector((state) => state.auth.user);
  const jwtToken = useSelector((state) => state.auth.generateToken);
  const [datas, setDatas] = React.useState({
    company_id: user?.company_id,
    employee_id: user?.employee_id,
    lat: "",
    lng: "",
    address: "",
    image: "",
    type: 0,
  });

  console.log("face", myFace);
  // console.log("data user", user);
  // console.log('datas', datas);

  const detectionOptions = {
    withLandmarks: true,
    withDescriptors: true,
    minConfidence: 0.5,
    MODEL_URLS: {
      Mobilenetv1Model:
        "https://raw.githubusercontent.com/ml5js/ml5-data-and-models/main/models/faceapi/ssd_mobilenetv1_model-weights_manifest.json",
      FaceExpressionModel:
        "https://raw.githubusercontent.com/justadudewhohacks/face-api.js/master/weights/face_expression_model-weights_manifest.json",
      TinyFaceLandmarkModel:
        "https://raw.githubusercontent.com/justadudewhohacks/face-api.js/master/weights/tiny_face_detector_model-weights_manifest.json",
      FaceLandmark68TinyNet:
        "https://raw.githubusercontent.com/justadudewhohacks/face-api.js/master/weights/face_landmark_68_model-weights_manifest.json",
      FaceRecognitionModel:
        "https://raw.githubusercontent.com/justadudewhohacks/face-api.js/master/weights/face_recognition_model-weights_manifest.json",
    },
  };

  React.useEffect(() => {
    setTimeout(() => {
      startVideoCapture();
    }, 2000);
  }, []);

  React.useEffect(() => {
    const loadModels = async () => {
      try {
        await Promise.all([
          faceapi.nets.ssdMobilenetv1.loadFromUri(
            detectionOptions.MODEL_URLS.Mobilenetv1Model
          ),
          faceapi.nets.tinyFaceDetector.loadFromUri(
            detectionOptions.MODEL_URLS.TinyFaceLandmarkModel
          ),
          faceapi.nets.faceLandmark68Net.loadFromUri(
            detectionOptions.MODEL_URLS.FaceLandmark68TinyNet
          ),
          faceapi.nets.faceRecognitionNet.loadFromUri(
            detectionOptions.MODEL_URLS.FaceRecognitionModel
          ),
          faceapi.nets.faceExpressionNet.loadFromUri(
            detectionOptions.MODEL_URLS.FaceExpressionModel
          ),
        ]);
        setModelsLoaded(true);
      } catch (error) {
        console.error("Failed to load models:", error);
      }
    };

    loadModels();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const startVideoCapture = () => {
    navigator?.mediaDevices
      .getUserMedia({ video: { width: 640, height: 640 } })
      .then((stream) => {
        let video = videoRef?.current;
        console.log("video", video);
        if (video) {
          video.srcObject = stream;
          video.onloadedmetadata = () => {
            video.play();
            // detectFaces();
          };
        } else {
          console.error("Video element not found");
          // window.location.reload();
        }
      })
      .catch((err) => {
        console.error("Failed to start video:", err);
      });
  };

  const getLabeledFaceDescriptions = async () => {
    const label = user.employee_fullname;
    const descriptions = [];
    const imgPath = myFace;
    // const imgPath = Kodir;

    const imgBlob = await fetch(imgPath).then((res) => res.blob());
    console.log("imgBlob", imgBlob);
    // console.log("imgPath", imgPath);
    const img = await faceapi.bufferToImage(imgBlob);
    // console.log("img", img);

    const detections = await faceapi
      .detectSingleFace(img)
      .withFaceLandmarks()
      .withFaceDescriptor();
    descriptions.push(detections.descriptor);

    return [new faceapi.LabeledFaceDescriptors(label, descriptions)];
  };

  const detectFaces = async () => {
    try {
      const labeledFaceDescriptors = await getLabeledFaceDescriptions();
      const faceMatcher = new faceapi.FaceMatcher(labeledFaceDescriptors);

      const video = videoRef.current;
      if (!video) return;

      const canvas = canvasRef.current;
      const context = canvas.getContext("2d", { willReadFrequently: true });

      if (!canvas || !context) return;

      const displaySize = { width: video.width, height: video.height };
      faceapi.matchDimensions(canvas, displaySize);

      setInterval(async () => {
        const detections = await faceapi
          .detectAllFaces(video)
          .withFaceLandmarks()
          .withFaceDescriptors();

        const resizedDetections = faceapi.resizeResults(
          detections,
          displaySize
        );

        canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);

        const results = resizedDetections.map((d) => {
          return faceMatcher.findBestMatch(d.descriptor);
        });

        results.forEach((result, i) => {
          const box = resizedDetections[i].detection.box;

          if (result._label !== "unknown") {
            const drawBox = new faceapi.draw.DrawBox(box, { label: result });
            drawBox.draw(canvas);
            setToggleButton(true);
          } else {
            context.strokeStyle = "red";
            context.lineWidth = 4;
            context.beginPath();
            context.rect(box.x, box.y, box.width, box.height);
            context.stroke();
            setToggleButton(false);
          }
        });
      }, 100);
    } catch (error) {
      console.error("Error detecting faces:", error);
    }
  };

  const takePhoto = () => {
    const canvas = canvasRef.current;
    if (canvas) {
      const photo = canvas.toDataURL("image/png");
      setCapturedPhoto(photo);
    }
    const formData = new FormData();
    formData.append("company_id", datas?.company_id);
    formData.append("employee_id", datas?.employee_id);
    formData.append("lat", datas?.lat);
    formData.append("lng", datas?.lng);
    formData.append("address", datas?.address);
    formData.append("image", canvas);
    formData.append("type", datas?.type);

    post(
      `public/api/v1/member/attendance/submit`,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "multipart/form-data",
        },
      },
      formData,
      (success) => {
        alert("absen berhasil");
        localStorage.setItem('absenSucces', success?.data?.Message);
        navigate("/");
      },
      (error) => {
        // console.log('error request', )
        alert(error?.data?.Message);
      }
    );
  };

  React.useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getProfile();
    }
    return () => isMounted === false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getProfile = () => {
    post(
      `public/api/v1/member/attribute`,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "application/json",
        },
      },
      { employee_id: user?.employee_id },
      (success) => {

        // console.log('res prof', success?.data?.Data?.object);

        const getLocation = () => {
          if (!navigator.geolocation) {
            console.log("Geolocation is not supported by your browser");
          } else {
            navigator.geolocation.getCurrentPosition(
              async (position) => {
                try {
                  const { latitude, longitude } = position.coords;
                  const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;
                  const response = await fetch(url);
                  const data = await response.json();
                  if (data.display_name) {
                    setDatas({
                      ...datas,
                      lat: latitude,
                      lng: longitude,
                      address: data.display_name,
                    });
                  } else {
                    console.log("Address not found in response:", data);
                  }
                } catch (error) {
                  console.error("Error fetching address:", error);
                }
              },
              () => {
                console.log("Unable to retrieve your location");
              }
            );
          }
        };

        getLocation();
        setMyFace(success?.data?.Data?.object?.crop_image_url);
      },
      (error) => {
        console.log("error request", error);
      }
    );
  };

  return (
    <div style={{ overflow: "hidden", background: "black", height: "100vh" }}>
      {captureVideo && modelsLoaded ? (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              // padding: "10px",
              position: "relative",
            }}
          >
            <img
              alt="logo_home"
              src={process.env.PUBLIC_URL + "/assets/img/arrow-left.svg"}
              className="absolute top-5 left-5 w-10 cursor-pointer z-99"
              onClick={() => navigate("/")}
              style={{ zIndex: 99 }}
            />
            <video
              ref={videoRef}
              height={videoHeight || 425}
              width={videoWidth || 425}
              onPlay={detectFaces}
              style={{ maxWidth: "100%", height: "auto" }}
            />
            <canvas
              ref={canvasRef}
              style={{ position: "absolute", maxWidth: "100%" }}
            />
          </div>
          {toggleButton && (
            <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 px-4 py-2">
              <button
                onClick={takePhoto}
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
              >
                Take Photo
              </button>
            </div>
          )}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
